import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext'; // Import the AuthProvider for context
import AuthGuard from './contexts/AuthGuard'; // Import the PrivateRoute for protecting routes
import ApiLogTable from './pages/Admin/Api_Logs/List';
import ChargesTable from './pages/Admin/Charges/List';
import CommodityTable from './pages/Admin/Commodity/List';
import DeviceConfigTable from './pages/Admin/Device_Config/List';
import FeeCollectionTable from './pages/Admin/Fee_Collection/List';
import FeeCollectionTempTable from './pages/Admin/Fee_Collection_Temp/List';
import FeeTypeTable from './pages/Admin/Fee_Type/List';
import PortTable from './pages/Admin/Port/List';
import PortTypeTable from './pages/Admin/Port_Type/List';
import SMSFormateTable from './pages/Admin/SMS_Formate/List';
import VesselTable from './pages/Admin/Vessel/List';
import UsersTable from './pages/Admin/Users/List';
import UnitTable from './pages/Admin/Unit/List';
import TransactionTable from './pages/Admin/Transaction/List';
import SubSubCommodityTable from './pages/Admin/Sub_Sub_Commodity/List';
import SubCommodityTable from './pages/Admin/Sub_Commodity/List';
import AuthLayout from './layouts/AuthLayout';
import LoginOTP from './pages/Reset_Password/LoginOTP';
import OpraterTable from './pages/Admin/Operator/List';
import ForgetPass from './pages/Reset_Password/ForgetPassword';
import ConfirmPassword from './pages/Reset_Password/ConfirmPassword';
import BalanceUpdateRequest from './pages/Admin/Balance_Update_Request/List';
import BalanceUpdateRequestAll from './pages/Admin/Balance_Update_Request_All/List';
import UserActivity from './pages/Admin/User_Activity/List';
import BankTable from './pages/Admin/Bank/List';

import { ToastContainer } from 'react-toastify';
import NotificationTable from './pages/Admin/Notification/List';
import VesselTypeTable from './pages/Admin/Vessel_Type/List';
import ChargeSlabTable from './pages/Admin/Charge_Slab/List';

function App() {

  return (
    <>
      <ToastContainer />
      <Router>
        <AuthProvider>
          <Routes>

            <Route path="/login"
              element={
                <AuthLayout>
                  <Login />
                </AuthLayout>
              }
            />

            <Route path="/Login_otp"
              element={
                <AuthLayout>
                  <LoginOTP />
                </AuthLayout>
              }
            />
            <Route path="/forget_pass"
              element={
                <AuthLayout>
                  <ForgetPass />
                </AuthLayout>
              }
            />
            <Route path="/confirm_password"
              element={
                <AuthLayout>
                  <ConfirmPassword />
                </AuthLayout>
              }
            />

            <Route
              path="/dashboard"
              element={
                <AuthGuard>
                  <MainLayout>
                    <Dashboard />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/"
              element={
                <AuthGuard>
                  <MainLayout>
                    <Dashboard />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/api_log_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <ApiLogTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/charges_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <ChargesTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/commodity_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <CommodityTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/device_config_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <DeviceConfigTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/fee_collection_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <FeeCollectionTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/fee_collection_temp_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <FeeCollectionTempTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/fee_type_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <FeeTypeTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/port_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <PortTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/port_type_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <PortTypeTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/sms_formate_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <SMSFormateTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/sub_commodity_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <SubCommodityTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/sub_sub_commodity_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <SubSubCommodityTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/transaction_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <TransactionTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/unit_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <UnitTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/users_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <UsersTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/oprater_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <OpraterTable />
                  </MainLayout>
                </AuthGuard>
              }
            />
            <Route
              path="/vessel_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <VesselTable />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/vessel_type_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <VesselTypeTable />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/charge_slab_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <ChargeSlabTable />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/balance_up_req"
              element={
                <AuthGuard>
                  <MainLayout>
                    <BalanceUpdateRequest />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/balance_up_req_all"
              element={
                <AuthGuard>
                  <MainLayout>
                    <BalanceUpdateRequestAll />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/user_activity"
              element={
                <AuthGuard>
                  <MainLayout>
                    <UserActivity />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/notification_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <NotificationTable />
                  </MainLayout>
                </AuthGuard>
              }
            />

            <Route
              path="/bank_table"
              element={
                <AuthGuard>
                  <MainLayout>
                    <BankTable />
                  </MainLayout>
                </AuthGuard>
              }
            />

          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;